import isEmpty from 'lodash/isEmpty';

export function getTreeKeys(tree) {
  if (isEmpty(tree)) return [];
  const keys = [];
  tree.map(node => {
    keys.push(node.id);
    keys.push(...getTreeKeys(node.children));
  });
  return keys;
}

function convertEconomic(eco, parent) {
  return {
    id: `eco-${eco.economicId}`,
    rawId: eco.economicId,
    label: eco.name,
    type: 'eco',
    labelPath: `${parent.labelPath}-${eco.name}`,
    parent,
    isOwnerFlag: eco.isOwnerFlag
  };
}

function convertPlan(plan, proj) {
  const p = {
    id: `plan-${plan.planId}`,
    rawId: plan.planId,
    label: plan.planName,
    type: 'plan',
    labelPath: `${proj.labelPath}-${plan.planName}`,
    parent: proj
  };
  if (!isEmpty(plan.economicList)) {
    p.children = plan.economicList.map(eco => convertEconomic(eco, p));
  }
  return p;
}

export function convertProject(project) {
  const proj = {
    id: `project-${project.projectId}`,
    rawId: project.projectId,
    label: project.projectName,
    type: 'project',
    labelPath: project.projectName,
    isOwnerFlag: project.isOwnerFlag
  };
  if (!isEmpty(project.economicList)) {
    proj.children = project.economicList.map(eco => convertEconomic(eco, proj));
  }
  return proj;
}

export function convertRelateTree(data) {
  if (isEmpty(data)) return [];
  return data.map(project => {
    const proj = {
      id: `project-${project.projectId}`,
      rawId: project.projectId,
      label: project.projectName,
      type: 'project',
      labelPath: project.projectName,
      children: []
    };
    if (!isEmpty(project.planList)) {
      proj.children.push(
        ...project.planList.map(plan => convertPlan(plan, proj))
      );
    }
    if (!isEmpty(project.economicList)) {
      proj.children.push(
        ...project.economicList.map(plan => convertEconomic(plan, proj))
      );
    }
    return proj;
  });
}

export function convertUnrelateTree(data) {
  if (isEmpty(data)) return [];
  return data.map(project => convertProject(project));
}

export function filterTree(tree, search) {
  if (!search) return tree;
  if (isEmpty(tree)) return [];
  const filtered = [];
  tree.forEach(node => {
    if (node.label && node.label.indexOf(search) !== -1) {
      filtered.push(node);
    } else {
      const children = filterTree(node.children, search);
      if (!isEmpty(children)) {
        filtered.push({
          ...node,
          children
        });
      }
    }
  });
  return filtered;
}
